import {
  Button,
  Card,
  CardContent,
  // IconButton,
  makeStyles,
  TableBody,
  TableCell,
  TableRow
} from "@material-ui/core";
// import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableHead from "@saleor/components/TableHead";
import { InstagramDetails_instagram_instagramtag } from "@saleor/instagram/types/InstagramDetails";
import { maybe, renderCollection } from "@saleor/misc";
import { ListActions, PageListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface InstagramTagListProps extends PageListProps, ListActions {
  instagramTag: InstagramDetails_instagram_instagramtag[];
  // deleteInsTag: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    colActions: {
      "&:last-child": {
        paddingRight: 5,
        paddingLeft: 0
      },
      width: 50 + theme.spacing(0.5)
    },
    colHeard: {
      textAlign: "left",
      width: "auto"
    },
    colName: {
      paddingLeft: 0,
      textAlign: "center",
      width: "auto"
    },
    colXY: {
      paddingLeft: 0,
      textAlign: "center",
      width: "20"
    },
    colNameLabel: {
      marginLeft: 31
    },
    colPublished: {
      width: 200
    },
    colType: {
      width: 200
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  {
    name:
      "C:Saleorsaleor-dashboardsrcinstagramcomponentsInstagramTagListInstagramTagList"
  }
);

const InstagramTagList: React.FC<InstagramTagListProps> = ({
  instagramTag,
  selected,
  disabled,
  toggleAll,
  isChecked,
  onRowClick,
  toggle,
  toolbar,
  onAdd
  // deleteInsTag
}) => {
  const intl = useIntl();
  const numberOfColumns = 8;
  const classes = useStyles();
  return (
    <div style={{ textAlign: "left", padding: 0, margin: 0 }}>
      {instagramTag && (
        <Card>
          <CardTitle
            title={intl.formatMessage({
              defaultMessage: "Tag List",
              description: "tag list"
            })}
            toolbar={
              <Button
                color={"primary"}
                onClick={onAdd}
                style={{ float: "right" }}
              >
                <FormattedMessage
                  defaultMessage="Add Tag"
                  description="button"
                />
              </Button>
            }
          ></CardTitle>
          <CardContent style={{ maxHeight: "720px", overflowY: "scroll" }}>
            <ResponsiveTable>
              <TableHead
                colSpan={numberOfColumns}
                selected={selected}
                disabled={disabled}
                items={maybe(() => instagramTag, undefined)}
                toggleAll={toggleAll}
                toolbar={toolbar}
              >
                <TableCell className={classes.colHeard} colSpan={3}>
                  <FormattedMessage
                    defaultMessage="Product Variant"
                    description="Product Variant"
                  />
                </TableCell>
                <TableCell className={classes.colXY}>
                  <FormattedMessage defaultMessage="PC-X" description="PC-X" />
                </TableCell>
                <TableCell className={classes.colXY}>
                  <FormattedMessage defaultMessage="PC-Y" description="PC-Y" />
                </TableCell>
                <TableCell className={classes.colXY}>
                  <FormattedMessage defaultMessage="MB-X" description="MB-X" />
                </TableCell>
                <TableCell className={classes.colXY}>
                  <FormattedMessage defaultMessage="MB-Y" description="MB-Y" />
                </TableCell>
                <TableCell className={classes.colActions} />
              </TableHead>
              <TableBody>
                {renderCollection(instagramTag, tag => {
                  const isSelected = tag ? isChecked(tag.id) : false;
                  return (
                    <TableRow
                      className={classes.tableRow}
                      hover={!!tag}
                      onClick={!!tag ? onRowClick(tag.id) : undefined}
                      key={tag ? tag.id : "skeleton"}
                      selected={isSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isSelected}
                          disabled={disabled}
                          disableClickPropagation
                          onChange={() => toggle(tag.id)}
                        />
                      </TableCell>
                      <TableCell className={classes.colType} colSpan={3}>
                        {maybe<React.ReactNode>(
                          () =>
                            tag.productvariant.product.name +
                            " " +
                            tag.productvariant?.attributes[0]?.values[0]?.value,
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell className={classes.colXY}>
                        {maybe<React.ReactNode>(() => tag.pcx, <Skeleton />)}
                      </TableCell>
                      <TableCell className={classes.colXY}>
                        {maybe<React.ReactNode>(() => tag.pcy, <Skeleton />)}
                      </TableCell>
                      <TableCell className={classes.colXY}>
                        {maybe<React.ReactNode>(() => tag.mbx, <Skeleton />)}
                      </TableCell>
                      <TableCell className={classes.colXY}>
                        {maybe<React.ReactNode>(() => tag.mby, <Skeleton />)}
                      </TableCell>
                      {/* <TableCell className={classes.colActions}>
                        <IconButton
                          disabled={!tag}
                          onClick={event => {
                            event.stopPropagation();
                            deleteInsTag(tag.id);
                          }}
                        >
                          <DeleteIcon color="primary" />
                        </IconButton>
                      </TableCell> */}
                    </TableRow>
                  );
                })}
              </TableBody>
            </ResponsiveTable>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
export default InstagramTagList;
